export const AGENT_TYPE = {
  ON_DEMAND: 'ON_DEMAND',
  INSTALLED_AGENT: 'INSTALLED_AGENT',
  CLASSROOM_AGENT: 'CLASSROOM_AGENT',
}
